var _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "play-store",
    xmlns: "http://www.w3.org/2000/svg",
    width: 102.12,
    height: 102.12,
    viewBox: "0 0 102.12 102.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5211",
    "data-name": "Group 5211"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5210",
    "data-name": "Group 5210"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8772",
    "data-name": "Path 8772",
    d: "M81.177,0H20.943A20.966,20.966,0,0,0,0,20.943V81.177A20.966,20.966,0,0,0,20.943,102.12H81.177A20.966,20.966,0,0,0,102.12,81.177V20.943A20.966,20.966,0,0,0,81.177,0ZM96.136,81.177A14.976,14.976,0,0,1,81.177,96.136H20.943A14.976,14.976,0,0,1,5.984,81.177V20.943A14.976,14.976,0,0,1,20.943,5.984H81.177A14.976,14.976,0,0,1,96.136,20.943Z",
    fill: "#ededed"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "google-play",
    transform: "translate(8.993 20.567)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5203",
    "data-name": "Group 5203",
    transform: "translate(19.86 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5202",
    "data-name": "Group 5202",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8768",
    "data-name": "Path 8768",
    d: "M55.86.976A7.743,7.743,0,0,0,48.3.995L76.087,26.626l9.334-9.334Z",
    transform: "translate(-48.302 0)",
    fill: "#ededed"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5205",
    "data-name": "Group 5205",
    transform: "translate(16.014 3.617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5204",
    "data-name": "Group 5204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8769",
    "data-name": "Path 8769",
    d: "M17.081,30.365a7.107,7.107,0,0,0-1.067,3.724V80.382a7.13,7.13,0,0,0,.995,3.632L44.95,56.073Z",
    transform: "translate(-16.014 -30.365)",
    fill: "#ededed"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5207",
    "data-name": "Group 5207",
    transform: "translate(50.446 19.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5206",
    "data-name": "Group 5206",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8770",
    "data-name": "Path 8770",
    d: "M324.01,166.19l-8.9-4.913-10,10,12.261,11.308,6.651-3.67a7.2,7.2,0,0,0,0-12.726Z",
    transform: "translate(-305.102 -161.277)",
    fill: "#ededed"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5209",
    "data-name": "Group 5209",
    transform: "translate(19.734 31.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5208",
    "data-name": "Group 5208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8771",
    "data-name": "Path 8771",
    d: "M75.263,267.9,47.246,295.918a7.726,7.726,0,0,0,7.684.072l31.776-17.536Z",
    transform: "translate(-47.246 -267.901)",
    fill: "#ededed"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/play-store.cb784e5c.svg";
export { ForwardRef as ReactComponent };